import { MS_PER_DAY } from './general';

/** Default minimum scheduled time in seconds (used when org has no setting). Must match server schema default. */
export const DEFAULT_MINIMUM_SCHEDULED_TIME_SECONDS = 60;

/** Default SERVICE reopen window duration in ms. Must match server `DEFAULT_REOPEN_WINDOW_DURATION_MS`. */
export const DEFAULT_REOPEN_WINDOW_DURATION_MS = MS_PER_DAY;
